import React, { useState, useEffect } from 'react';
import CmsService from 'services/CMS';
import { withRouter } from "react-router";
import Loader from "components/Loader/index";
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR


const HelpCenterSearchCategory = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [category, setCategories] = useState([]);

    useEffect(() => {
        CmsService.getListHelpCenterCategories().then((result) => {
            if(result) {
                setCategories(result);
            }else{
                setCategories([]);
            }
            setIsLoaded(true);
        });
    },[]);


    const goToCategory = (item, e) => {
        props.history.replace(`/centro-ayuda/categoria/${item.slug}`);
        e.preventDefault();
    }

    return (
        <section className={'search-department-wrapper'}>
            <h2 className={'search-helpcenter-department-title'}>Busca en otro categorías</h2>
            {isLoaded && <div className="helpcenter-search-categories-wrap">
                {category && category.map((item, i) =>{
                    return (
                        <div className="helpcenter-search-categories-box" key={i} onClick={(e) => goToCategory(item, e)}>
                            <div className="helpcenter-search-categories-info-text-wrap">
                                <span className="helpcenter-search-categories-info-title">{item.name}</span>
                            </div>
                        </div>
                    )
                })}
            </div>}
            {!isLoaded && <Loader />}
        </section>
    )
}

HelpCenterSearchCategory.propTypes = {
    history: PropTypes.object
};

export default withRouter(HelpCenterSearchCategory);
